import { useEffect } from 'react';

/** Reads the selected i-text's properties into the text setters; `onCleared` runs when the selection empties. */
const useTextSelection = (canvasRef, setters, onCleared) => {
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return undefined;
        const read = () => {
            const active = canvas.getActiveObject();
            if (!active || !active.isType('i-text')) return;
            const styles = [];
            if (active.fontWeight === 'bold') styles.push('bold');
            if (active.fontStyle === 'italic') styles.push('italic');
            if (active.textDecoration === 'underline') styles.push('underline');
            setters.setTextSize(active.fontSize || 10);
            setters.setTextColor(active.fill || '#000000');
            setters.setTextFont(active.fontFamily || 'Times New Roman');
            setters.setTextStyle(styles);
        };
        read();
        canvas.on('selection:updated', read);
        canvas.on('selection:cleared', onCleared);
        return () => {
            canvas.off('selection:updated', read);
            canvas.off('selection:cleared', onCleared);
        };
    }, [canvasRef, setters, onCleared]);
};

export default useTextSelection;
